var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { App, Aggregator, Env, container, ENV_KEY } from "@al/aku-lc-core";
import { AppContext, CreateRootContext, EnvContext, LocaleContext, SchemaExpressionContext, } from "../context";
import { useAttach } from "../hooks";
import { RecursionWidget } from "./RecursionWidget";
export function createRoot(options) {
    var aggregator = new Aggregator();
    var rootStore = new App(aggregator);
    var env = new Env({
        fetcher: options.fetcher,
        notify: options.notify,
        extraConfig: options.extraConfig,
        translate: options.translate,
        eventTracking: options.eventTracking,
        app: rootStore,
    });
    container.inject(ENV_KEY, env);
    function Root(props) {
        var appState = useAttach(rootStore);
        var renderChildren = function () {
            return (React.createElement(RecursionWidget, __assign({}, props, { schema: props.schema.schema, version: props.schema.metadata.version, force: props.forceUpdate })));
        };
        var context = __assign(__assign({ $app: {}, $deps: {}, $self: {} }, options.context), props.context);
        return (React.createElement(EnvContext.Provider, { value: env },
            React.createElement(AppContext.Provider, { value: appState },
                React.createElement(LocaleContext.Provider, { value: options.locale || props.locale || "en" },
                    React.createElement(CreateRootContext.Provider, { value: __assign(__assign({}, options), { context: __assign({ $app: {}, $deps: {}, $self: {} }, options.context), widgets: __assign(__assign({}, options.widgets), props.widgets) }) },
                        React.createElement(SchemaExpressionContext.Provider, { value: context }, renderChildren()))))));
    }
    Root.displayName = "Root";
    return Root;
}
